import $ from 'jquery'
import { Modal } from 'bootstrap'

// eslint-disable-next-line no-undef
const object = casanovaObject

const certs = $('.feed-certification')
certs.each(function () {
  const $this = $(this)

  $this.on('click', function (e) {
    e.stopPropagation()
  })

  $this[0].addEventListener('show.bs.modal', (event) => {
    const id = event.relatedTarget.getAttribute('data-id')
    const body = event.target.querySelector('.modal-body')

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        _ajax_nonce: object.nonce,
        action: 'casanova_get_cert_content',
        id,
      },
      beforeSend: () => {},
      success: (res) => {
        body.innerHTML = res.data.content
      },
    })
  })

  $this[0].addEventListener('hidden.bs.modal', (event) => {
    event.target.querySelector('.modal-body').innerHTML = object.loader
  })
})
